import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选剧场
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            热门影视精选，高清画质畅享观影
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200/50">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/90 text-foreground-800 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.quality}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.source}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}